.info {
  width: 100%;
  padding: var(--gac-space-sm) var(--gac-space-md);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
}

.warning {
  width: 100%;
  padding: var(--gac-space-sm) var(--gac-space-md);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-status-warning);
}

.error {
  width: 100%;
  padding: var(--gac-space-xs) var(--gac-space-sm);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-status-danger);
}

.amountInput {
  width: 100%;
  box-sizing: border-box;
  padding: var(--gac-space-xs) var(--gac-space-sm);
  border-radius: var(--gac-radius-sm);
  border: 1px solid var(--gac-line-border);
  background: var(--gac-surface-hover);
  color: var(--gac-text-primary);
  /* 16px, not 15: below 16 iOS Safari zooms the page into a focused field, and the viewport no
     longer forbids zoom (BUG-11) — the sheet would stay zoomed and clipped after blur. */
  font-size: 16px;
  color-scheme: dark;
}
